module.exports = __webpack_public_path__ + "img/blademaster_small.dbde6d54.png";